import React from "react";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import MuiButton from "../../components/basicComponent/MuiButton";
import { MuiInput } from "../../components/basicComponent/MuiInput";
import MuiDatePicker from "../../components/basicComponent/MuiDatePicker";

const SupplierCommissionDetails = () => {
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header text-center">
              <h3 className="card-title">Supplier Commission Details</h3>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    <div className="row mt-4">
                      <div className="col-md-4">
                        <MuiInput
                          label={"Agent Name"}
                          placeholder="Agent Name"
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDatePicker
                        label="From Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4">
                        <MuiDatePicker
                        label="To Date"
                          value={null}
                          onChange={function (date: string): void {
                            throw new Error("Function not implemented.");
                          }}
                        />
                      </div>
                      <div className="col-md-4  mt-3">
                        <MuiInput
                          label={"S PNR"}
                          placeholder="S PNR"
                        />
                      </div>
                      <div className="col-md-4  mt-3">
                        <MuiInput
                          label={"Airline PNR"}
                          placeholder="Airline PNR"
                        />
                      </div>
                      <div className="col-md-4  mt-3">
                        <MuiInput
                          label={"CRS PNR"}
                          placeholder="CRS PNR"
                        />
                      </div>
                      <div className="col-md-4  mt-3">
                        <MuiInput
                          label={"Airline Category"}
                          placeholder="Airline Category"
                        />
                      </div>{" "}
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Airline Category"}
                          placeholder="Airline Category"
                        />
                      </div>
                      <div className="col-md-4 mt-3">
                        <MuiInput
                          label={"Airline Name"}
                          placeholder="Airline Name"
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: "10px",
                          marginTop: "8px",
                        }}
                      >
                        <div className="user-button w-full">
                          <MuiButton
                            className="clear-btn "
                            label="Clear"
                            type="submit"
                          />
                          <MuiButton
                            label={"Get"}
                            className="main-btn get-btn"
                            variant="contained"
                            size="large"
                            type="submit"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SupplierCommissionDetails;
